import loading from '@wtdc/feed-loading';

import book from './book';
import reader from './reader';
import nft from './nft';
import member from './member';
import learning from './learning';
import calligraphy from './calligraphy';

export default [
  loading,
  book,
  reader,
  nft,
  member,
  learning,
  calligraphy
];
